// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25825":"e845306715617e76aaa4","51231":"12aeb6e7676a806beba2"}[chunkId] + ".css";
};